<div class="modal-header">
    <ion-grid class="ion-no-padding">
        <ion-row class="ion-no-padding">
            <ion-col size="10"
                     class="ion-no-padding">
                {{ 'ASK_THE_SPEAKER_MODAL_HEADER' | translate }}
            </ion-col>
            <ion-col size="2"
                     class="ion-no-padding ion-text-right">
                <a (click)="close()">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-close.svg"
                              class="icon fill-dark"></svg-icon>
                </a>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>

<ion-row class="speaker ion-no-padding">
    <ion-col size="3"
             size-sm="2"
             class="ion-no-pading">
        <ion-avatar (click)="showSpeakerDetail(speaker);"
                    [ngClass]="{'pointer': speaker.participant_id || speaker.external_link}">
            <img *ngIf="speaker.image_url || speaker.participant?.picture_url"
                 img-avatar
                 [random]="speaker.id"
                 [src]="speaker.image_url || speaker.participant?.picture_url">
            <svg-icon *ngIf="!(speaker.image_url || speaker.participant?.picture_url)"
                      [applyClass]="true"
                      [class]="'avatar-fill-' + speaker.id % 3 "
                      src="/assets/icons/ico-avatar-empty.svg"></svg-icon>
        </ion-avatar>
    </ion-col>
    <ion-col size="9"
             size-sm="10"
             class="ion-no-padding">
        <div (click)="showSpeakerDetail(speaker);"
             [ngClass]="{'pointer': speaker.participant_id || speaker.external_link}">
            <h3>{{ speaker.name || speaker.participant?.getFullName() | cut: 60 }}</h3>
            <p class="position">{{ speaker.position || speaker.participant?.company | cut: 100 }}</p>
        </div>
    </ion-col>
</ion-row>

<form method="get"
      #f="ngForm"
      role="form"
      novalidate
      class="ion-no-padding">
    <ion-grid class="ion-no-padding">
        <ion-row class="ion-no-padding">
            <ion-col class="ion-no-padding">
                <ion-item class="ion-no-padding"
                          [ngClass]="{ 'has-error': validate && validationErrors['question'] }">
                    <ion-label position="stacked">{{ 'ASK_THE_SPEAKER_QUESTION_LABEL' | translate }}</ion-label>
                    <ion-textarea placeholder="{{ 'ASK_THE_SPEAKER_QUESTION_PLACEHOLDER' | translate }}"
                                  ieTextareaFix
                                  name="questionInput"
                                  inputmode="text"
                                  spellcheck="false"
                                  autocapitalize="off"
                                  #questionInput="ngModel"
                                  [(ngModel)]="question.question">
                    </ion-textarea>
                </ion-item>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="env.atsAnonymous" class="ion-no-padding">
            <ion-col class="ion-no-padding">
                <ion-item class="ion-no-margin">
                    <ion-checkbox id="anonymous"
                                  name="anonymous"
                                  slot="start"
                                  [(ngModel)]="question.anonymous"></ion-checkbox>
                    <label for="anonymous">{{ 'ASK_THE_SPEAKER_ANONYMOUS_LABEL' | translate }}</label>
                </ion-item>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="validate && validationErrors['question']"
                 class="ion-no-padding">
            <ion-col class="ion-no-padding">
                <div class="error-message">
                    {{ validationErrors['question'] }}
                </div>
            </ion-col>
        </ion-row>
        <ion-row class="ion-no-padding">
            <ion-col class="ion-no-padding ion-text-right">
                <ion-button class="btn-close"
                            color=""
                            (click)="close()">
                    {{ 'BUTTON_CANCEL' | translate }}
                </ion-button>
                <ion-button color="primary"
                            [disabled]="!question.question || submit"
                            (click)="sendQuestion(f.form.valid)">
                    {{ 'BUTTON_SEND_QUESTION' | translate }}
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-grid>
</form>
